import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import { withRouter } from "react-router-dom";
import ThemeButton from "./ThemeButton";

import CartItem from "./CartItem";

import cartLogo from "images/cart-logo.svg";
import "css/Cart.css";

class Cart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            opened: false,
            displayedProduct: 0
        };
    }

    render() {

        const isOnSummary = this.props.history.location.pathname === "/Summary";
        
        return (
            <div className="Cart">
                <div className={"cart-container" + (this.state.opened ? " opened" : "")}>
                    <div className="cart-wrapper" onClick={() => this.setState({ opened: !this.state.opened })}>
                        <img src={cartLogo} alt="Cart" />
                        {this.props.ProductList.length !== 0 && <span style={{paddingTop: "1.5px"}}>{this.props.ProductList.length}</span>}
                    </div>
                    {this.state.opened && (
                        <div className="cart-list-wrapper">
                            <h4>Your Items</h4>
                            {/* {!emptyWER && this.props.selectedWERId && <WerSelector werList={this.props.WERList} selectedId={this.props.selectedWERId} />} */}
                            <div className="cart-list">
                                <div>
                                    {this.props.ProductList && this.props.ProductList.length !== 0 && <CartItem Product={this.props.ProductList[this.state.displayedProduct]} />}
                                    {!(this.props.ProductList && this.props.ProductList.length !== 0) && <p>Your cart is empty</p>}
                                </div>
                            </div>
                            {!isOnSummary &&
                                <div className="cart-button">
                                    <ThemeButton inCart onClick={() =>{this.props.history.push("/Summary");}}>go to summary</ThemeButton>
                                </div>
                            }

                            <div className="cart-tabs">
                                {$.map(this.props.ProductList, (value, index) => (
                                    <span
                                        key={index}
                                        className={this.state.displayedProduct === index ? "selected" : ""}
                                        onClick={() => this.setState({ displayedProduct: index })}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {this.state.opened && <div className="opened-cart-overlay" onClick={() => this.setState({ opened: !this.state.opened })} />}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ProductList: state.ProductList,
        WERList: state.Window.WERs,
        selectedWERId: 2
    };
};

export default withRouter(connect(mapStateToProps)(Cart));


// WEBPACK FOOTER //
// ./src/components/Cart.js